import { SCHEDULE_PERMISSION } from "@constants/api";
import { AlertResultApi } from "@utils/alert";
import axios from "axios";
import { types, flow } from "mobx-state-tree";
import { FetchingEnum } from "./Fetching";
import { ChildType } from "./SchedulePermission";

export const initialStateRenewal = {
  fetchingRevewal: FetchingEnum.DONE,
  fetchingCheckRenewalChild: FetchingEnum.DONE,
  fetchingPutRenewalChild: FetchingEnum.DONE,
};

export const Renewal = types
  .model({
    fetchingRenewalScheduleChild: FetchingEnum.DONE,
    statusRenewalScheduleChild: types.maybeNull(types.number),

    fetchingCheckRenewalChild: FetchingEnum.DONE,
    statusCheckRenewalChild: types.maybeNull(types.number),

    fetchingPutRenewalChild: FetchingEnum.DONE,
    statusPutRenewalChild: types.maybeNull(types.number),
  })
  .actions((self) => ({
    getRenewalScheduleChild: flow(function* (
      token: string,
      children: ChildType[],
      callback: (data: RenewalCheckType) => void
    ) {
      children.forEach(
        flow(function* (child) {
          if (child.isMain) {
            self.fetchingRenewalScheduleChild = FetchingEnum.PENDING;
            self.statusRenewalScheduleChild = null;
            try {
              const response = yield axios.get(
                `${SCHEDULE_PERMISSION}/${child.id}/renewal`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
              self.fetchingRenewalScheduleChild = FetchingEnum.DONE;
              self.statusRenewalScheduleChild = response.status;
              if (response.data?.isMaxLevel === false) {
                callback(response.data);
                return true;
              }
            } catch (error) {
              self.fetchingRenewalScheduleChild = FetchingEnum.DONE;
              AlertResultApi(
                error?.response?.status || 500,
                error?.response?.data?.message || error.response
              );
              return true;
            }
          }
        })
      );
    }),
    getCheckRenewalChild: flow(function* (
      token: string,
      child: ChildType,
      callback: (data: RenewalCheckType) => void
    ) {
      self.fetchingCheckRenewalChild = FetchingEnum.PENDING;
      self.statusCheckRenewalChild = null;
      try {
        const response = yield axios.get(
          `${SCHEDULE_PERMISSION}/${child.id}/renewal`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        self.fetchingCheckRenewalChild = FetchingEnum.DONE;
        self.statusCheckRenewalChild = response.status;

        callback(response.data);
      } catch (error) {
        self.fetchingCheckRenewalChild = FetchingEnum.DONE;
        self.statusCheckRenewalChild = error?.response?.status || 500;
        AlertResultApi(
          error?.response?.status || 500,
          error?.response?.data?.message || error.response
        );
      }
    }),
    putRenewalScheduleChild: flow(function* putRenewalScheduleChild(
      token: string,
      studentId: number,
      isAcceptRenewal: boolean,
      academicYearId: number,
      callback: (result: any) => void
    ) {
      self.fetchingPutRenewalChild = "pending";
      self.statusPutRenewalChild = null;
      try {
        // ... yield can be used in async/await style
        const result = yield axios.request({
          method: "put",
          url: `${SCHEDULE_PERMISSION}/${studentId}/renewal`,
          data: {
            studentId: studentId,
            isAcceptRenewal: isAcceptRenewal,
            academicYearId: academicYearId,
          },
          headers: { Authorization: `Bearer ${token}` },
        });
        self.fetchingPutRenewalChild = "done";
        self.statusPutRenewalChild = result.status;
        // self.token = result.data.token;
        callback(result);
      } catch (error) {
        console.error("Failed to fetch projects", error);
        self.fetchingPutRenewalChild = "error";
        self.statusPutRenewalChild = error?.response?.status || 500;
        AlertResultApi(
          error?.response?.status || 500,
          error?.response?.data?.message || error.response
        );
      }
    }),
  }));
